module.exports = __webpack_public_path__ + "img/2.04547ed0.png";